import React from 'react';

import { getLeftPanelProps } from './utils';
import { getUITA } from '../../../utils/commonUtils';
import CustomGridPanel from '../CustomGridPanel/CustomGridPanel';

function LeftPanel({ children, config, setConfig, ...otherProps }) {
  const panelProps = getLeftPanelProps({ config, setConfig, otherProps });

  return (
    <CustomGridPanel
      {...otherProps}
      {...panelProps}
      styles={{ height: '100%' }}
      testAutomation={getUITA('TaskStatusPanel')}
    >
      {children}
    </CustomGridPanel>
  );
}

export default LeftPanel;
